import React from 'react';
import { useInlineEdit } from '../../context/InlineEditContext';
import { Pencil, Eye, Send, Loader2 } from 'lucide-react';

/**
 * InlineEditToolbar — floating bottom-right toolbar shown to admins on public pages.
 * Two buttons:
 *  - Toggle Edit Mode ON/OFF
 *  - Publish Draft (only when there are unsaved drafts)
 */
export const InlineEditToolbar = () => {
  const { enabled, isAdmin, toggle, publishAll, dirty, saving } = useInlineEdit();
  if (!isAdmin) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[95] flex items-center gap-2" data-testid="inline-edit-toolbar">
      {enabled && dirty && (
        <button
          type="button"
          onClick={publishAll}
          disabled={saving}
          className="flex items-center gap-2 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold px-4 py-2.5 shadow-xl transition-all"
          data-testid="inline-publish-btn"
        >
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
          Publish Draft
        </button>
      )}
      <button
        type="button"
        onClick={toggle}
        className={`flex items-center gap-2 rounded-full text-sm font-semibold px-4 py-2.5 shadow-xl transition-all ${
          enabled
            ? 'bg-amber-500 hover:bg-amber-600 text-white'
            : 'bg-white hover:bg-slate-50 text-[#00457f] border border-slate-200'
        }`}
        title={enabled ? 'Exit edit mode' : 'Enter inline edit mode'}
        data-testid="inline-edit-toggle"
      >
        {enabled ? <Eye className="w-4 h-4" /> : <Pencil className="w-4 h-4" />}
        {enabled ? 'Exit Edit Mode' : 'Edit Mode'}
      </button>
    </div>
  );
};
